const SetupMixin = {
  methods: {
    getSetups: function (setups = []) {
      setups.forEach((setup) => {
        this.$store.dispatch(`Setup/${setup}`);
      });
    },
  },

  computed: {
    membershipCategories() {
      return this.$store.getters["Setup/membershipCategories"];
    },
    companyInformation() {
      return this.$store.getters["Setup/companyInformation"];
    },
    countries() {
      return this.$store.getters["Setup/countries"];
    },
    cities() {
      return this.$store.getters["Setup/cities"];
    },
    counties() {
      return this.$store.getters["Setup/counties"];
    },
    postalCodes() {
      return this.$store.getters["Setup/postalCodes"];
    },
  },
};

export default SetupMixin;
